import { useState } from 'react';
import { useNavigate, useSearchParams, Link } from 'react-router-dom';
import { Card } from '@/components/ui/card';
import { Button } from '@/components/ui/button';
import { Input } from '@/components/ui/input';
import { Label } from '@/components/ui/label';
import { api } from '@/lib/api';
import { toast } from 'sonner';
import { useAuth } from '@/contexts/AuthContext';

const ResetPassword = () => {
  const [sp] = useSearchParams();
  const nav = useNavigate();
  const { refresh } = useAuth();
  const token = sp.get('token') || '';
  const [pw, setPw] = useState('');
  const [pw2, setPw2] = useState('');
  const [busy, setBusy] = useState(false);

  const submit = async (e) => {
    e?.preventDefault?.();
    if (!token) { toast.error('Reset link is invalid'); return; }
    if (pw.length < 8) { toast.error('Password must be 8+ characters with letters & digits'); return; }
    if (pw !== pw2) { toast.error('Passwords do not match'); return; }
    setBusy(true);
    try {
      const { data } = await api.post('/auth/password/reset', { token, new_password: pw });
      if (data?.session_token) localStorage.setItem('session_token', data.session_token);
      await refresh?.();
      toast.success('Password reset successfully — you are now signed in.');
      nav('/');
    } catch (e2) {
      const msg = e2.response?.data?.detail;
      toast.error(typeof msg === 'string' ? msg.replace(/_/g, ' ') : 'Reset failed');
    } finally { setBusy(false); }
  };

  return (
    <div className="min-h-screen bg-gradient-to-br from-[#1E3A8A] to-[#1D4ED8] flex items-center justify-center p-4">
      <Card className="max-w-md w-full p-6 shadow-2xl" data-testid="reset-password-card">
        <h1 className="text-2xl font-black display text-[#1E3A8A] mb-1">Set new password</h1>
        <p className="text-xs text-[var(--bz-muted)] mb-4">Min 8 characters with at least one letter and one digit.</p>
        <form onSubmit={submit} className="space-y-3">
          <div>
            <Label>New password</Label>
            <Input type="password" value={pw} onChange={e => setPw(e.target.value)} data-testid="reset-pw-input" autoFocus />
          </div>
          <div>
            <Label>Confirm new password</Label>
            <Input type="password" value={pw2} onChange={e => setPw2(e.target.value)} data-testid="reset-pw2-input" />
          </div>
          <Button type="submit" disabled={busy} className="w-full bg-[#1D4ED8] hover:bg-[#1E3A8A] h-11 font-bold display" data-testid="reset-submit-btn">
            {busy ? 'Saving…' : 'Reset password'}
          </Button>
          <div className="text-xs text-center"><Link to="/login" className="text-[#1D4ED8] underline">← Back to login</Link></div>
        </form>
      </Card>
    </div>
  );
};

export default ResetPassword;
